module.exports = __webpack_public_path__ + "static/media/11NEPAD8.cfb073b8.jpg";